<template>
  <div class="header-bar">
    <div class="title">{{ title }}</div>
    <div class="flex">
      <span class="minimize"></span>
      <!-- <span class="close"></span> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "HeadBar",
  props: {
    title: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="scss" scoped>
.header-bar {
  background: #506fe9;
  border: 1px solid rgba(35, 64, 176, 1);
  border-radius: 2px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px 0 20px;
  .title {
    font-family: AlibabaPuHuiTi-Medium;
    font-size: 20px;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 500;
  }
  .minimize {
    display: inline-block;
    width: 40px;
    height: 30px;
    // margin-right: 14px;
    background: url("~@/assets/activity/learningStar/head-sm.png") 50% 50%
      no-repeat;
    background-size: contain;
  }
  .flex {
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/activities/learningStar/components/HeadBar.vue